import React from "react";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { BsSearch } from "react-icons/bs";
import "./index.css";

const Header = () => {
  return (
    <div className="header-container">
      <div className="logo-container">
        <Link to={"/"}>
          <img
            src="https://res.cloudinary.com/dbsdzzvez/image/upload/v1719641843/SKU%20Frontend%20Files/wnubnkvhkdlvwj3gzbtv.jpg"
            alt="logo"
            className="logo-img"
          />
        </Link>
      </div>
      <p className="results-para">Results 2024</p>
      <div className="title-container">
        <Link to={"/"} className="title-text">
          <p className="title-text">Q Papers Telugu</p>
        </Link>
      </div>
      <div className="search-input-container">
        <input type="text" className="search-input" />
        <div className="search-icon-box">
          <BsSearch />
        </div>
      </div>
      <div class="dropdown">
        <button class="dropbtn">
          <FaBars className="icon-bars" />
        </button>
        <div class="dropdown-content">
          <li className="dropdown-list">
            <Link className="dropdown-link" to={"/about"}>
              About
            </Link>
          </li>
          <li className="dropdown-list">Services</li>
          <li className="dropdown-list">More</li>
        </div>
      </div>
    </div>
  );
};

export default Header;
